import { gql } from 'graphql-tag';

const resourceMatchesFragment = gql`
  fragment ResourceMatchesFragment on ResourceRequest {
    resourceMatches(
      page: $resourceMatchesPage
      pageSize: $resourceMatchesPageSize
    ) @include(if: $isPsaPraaResourceMatchingEnabled) {
      id
      userUri
      score
      displayText
      availabilityPercentageInDateRange
    }
    resourceMatchesStatus @include(if: $isPsaPraaResourceMatchingEnabled)
  }
`;

export default resourceMatchesFragment;
